/**
 * Keep number-input spinner buttons, but ignore mouse-wheel changes when the
 * field is focused (accidental scroll was changing values rapidly).
 * Safe to call multiple times — installs once per page.
 */
export function disableNumberInputWheel () {
  if (typeof document === 'undefined') return
  if (window.__disableNumberInputWheelInstalled) return
  window.__disableNumberInputWheelInstalled = true

  document.addEventListener(
    'wheel',
    (event) => {
      const target = event.target
      if (!(target instanceof HTMLInputElement) || target.type !== 'number') return
      if (document.activeElement !== target) return
      event.preventDefault()
    },
    { passive: false, capture: true }
  )
}

disableNumberInputWheel()
